import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AttachmentsPageLoader: LoadableType<{
	contentId: string;
	spaceKey: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AttachmentsPage" */ '../src/AttachmentsPage.tsx'))
			.AttachmentsPage,
});
